import fetchServer from "../../../fetchServer";

export default async function addRefundMessage(id, data) {
  var result = { return: 0, msg: "Failed submitting message", data: [] };

  await fetchServer({
    method: "POST",
    url: `/product/v1/refund/addMessage/${id}`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status >= 200 && res?.status < 300) {
          result = { return: 1, msg: "Successful", data: res.data.data };
        } else if (res?.data?.error) result["msg"] = res.data.error;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
